import PlanboardMode from './PlanboardMode'

export default class PlanboardModeShowBooking extends PlanboardMode {
  setProductGroupTitle() {
    //do nothing
  }
}
